import { AutoField, ComponentConfig, FieldLabel } from "@measured/puck";
import { Section } from "@/lib/puck/components/Section";
import { Link2 } from "lucide-react";

export type ImageProps = {
  url?: string;
};

export const Image: ComponentConfig<ImageProps> = {
  label: "Image",
  fields: {
    url: {
      type: "custom",
      render: ({ value, field, name, onChange, readOnly }) => (
        <FieldLabel
          label={field.label || name}
          readOnly={readOnly}
          icon={<Link2 size="16" />}
        >
          <AutoField
            field={{ type: "text" }}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        </FieldLabel>
      ),
    },
  },
  defaultProps: {
    url: "",
  },
  render: ({ url }) => (
    <Section>
      {url ? (
        <img
          src={url}
          alt="Image"
          className="w-full h-auto rounded-md object-cover"
        />
      ) : (
        <div className="w-full h-64 bg-zinc-200 rounded-md flex items-center justify-center">
          <span className="text-zinc-600">Image Placeholder</span>
        </div>
      )}
    </Section>
  ),
};
